/*
 * @Author: Pluto 66291979@qq.com
 * @Date: 2024-05-22 13:51:37
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-02-18 19:18:25
 * @FilePath: /lobby/src/locales/index.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { defaultCountry } from '@/common/config'
import { getLocalStorage, Key, setLocalStorage } from '@/common/localStorage'
import { nextTick } from 'vue'
import { createI18n } from 'vue-i18n'

function getLocalLanguage() {
  let languageu = 'en'
  switch (defaultCountry()) {
    case 'ET':
      languageu = 'en'
      break
    case 'CI':
      languageu = 'fr'
      break
    case 'KE':
      languageu = 'en'
      break
    case 'TZ':
      languageu = 'sw'
      break
    default:
      break
  }
  return languageu
}
function getLocale() {
  let locale = getLocalStorage(Key.Locale)
  return locale || getLocalLanguage()
}

function setLocale(locale) {
  setLocalStorage(Key.Locale, locale)
}

const i18n = setupI18n({
  locale: getLocale(),
  globalInjection: true,
  silentTranslationWarn: true,
  warnHtmlInMessage: 'off'
})

function setupI18n(options = { locale: getLocalLanguage() }) {
  const i18n = createI18n(options)
  setI18nLanguage(i18n, options.locale)
  return i18n
}

function setI18nLanguage(i18n, locale) {
  if (i18n.mode === 'legacy') {
    i18n.global.locale = locale
  } else {
    i18n.global.locale.value = locale
  }
  /**
   * NOTE:
   * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
   * The following is an example for axios.
   *
   * axios.defaults.headers.common['Accept-Language'] = locale
   */
  // document.querySelector('html').setAttribute('lang', locale)

  // 加载语言包
  loadLocaleMessages(i18n, locale).then(() => {
    console.log(`loading lang=${locale}`)
  })
}

// async function loadLocaleMessages(i18n, locale) {
//   // load locale messages with dynamic import
//   const messages = await import(/* webpackChunkName: "locale-[request]" */ `../lang/${locale}.json`)

//   // set locale and locale message
//   i18n.global.setLocaleMessage(locale, messages.default)

//   return nextTick()
// }
async function loadLocaleMessages(i18n, locale) {
  // load locale messages from remote server
  try {
    const response = await fetch(
      `https://res.megalake.games/lang/${window.language[locale]}.json?timestamp=${Date.now()}`,
      {
        cache: 'no-cache' // 避免缓存问题
      }
    )
    let messages = {}
    if (!response.ok) {
      messages = await import(
        /* webpackChunkName: "locale-[request]" */ `../lang/${getLocale()}.json`
      )
      console.error(`NetWork Error Code: ${response.status}`)
    } else {
      messages = await response.json()
    }

    // set locale and locale message
    i18n.global.setLocaleMessage(locale, messages)
  } catch (error) {
    console.error('loadLocaleMessages error:', error)
    const VERSION_JSON_URL = `https://res.megalake.games/app/version.json?timestamp=${Date.now()}`
    fetch(VERSION_JSON_URL, {
      cache: 'no-cache' // 避免缓存问题
    })
      .then((response) => {
        console.log('VERSION_JSON_URL=====>>>>>>', VERSION_JSON_URL)
        console.log('response=====>>>>>>', response)
        if (!response.ok) {
          throw new Error(`NetWork Error Code: ${response.status}`)
        }
        response.json().then(({ language }) => {
          window.language = language
          loadLocaleMessages(i18n, locale)
        })
      })
      .catch(async () => {
        let messages = {}
        messages = await import(
          /* webpackChunkName: "locale-[request]" */ `../lang/${getLocale()}.json`
        )
        i18n.global.setLocaleMessage(locale, messages)
      })
  }

  return nextTick()
}

export { i18n, setI18nLanguage, getLocale, setLocale }
